import React from 'react'
import { View, ViewPropTypes } from 'react-native'
import PropTypes from 'prop-types'

import Txt from '../../../../components/Txt'
import Icon from '../../../../components/Icons'
import styles from './styles'
import { useTheme } from '../../../../theming/ThemeProvider'

const LoadDetail = ({ icon, title, text, style }) => {
  const { theme } = useTheme()
  return (
    <View style={[styles.container, style]}>
      {icon && (
        <View style={styles.iconContainer}>
          <Icon
            name={icon}
            width={30}
            height={30}
            fill={theme.GEYSER}
          />
        </View>
      )}
      <View style={styles.textContainer}>
        <Txt
          text={text || '--'}
          identity='body2Bold'
          selectable
        />
        <Txt
          text={title || '--'}
          identity='body2'
          color='OUTER_SPACE'
        />
      </View>
    </View>
  )
}

LoadDetail.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  style: ViewPropTypes.style
}

export default LoadDetail
